import React, { useState } from "react";
import { BoxButton, CDialog, Icon } from "shared";
import { Replay } from "@material-ui/icons";
import ReopenAccountForm from "./ReopenPatientAccountForm";
import { useTranslation } from "react-i18next";

const ReopenAccount: React.VFC = () => {
  const [isOpen, setOpen] = useState(false);
  const { t } = useTranslation();

  const closeDialog = () => setOpen(false);
  const openDialog = () => setOpen(true);

  return (
    <>
      <BoxButton startIcon={<Icon of={Replay} />} onClick={openDialog}>
        {t("patients.reopen_account")}
      </BoxButton>

      <CDialog maxWidth="xs" fullWidth open={isOpen} onClose={closeDialog} aria-labelledby="reopen-account">
        <ReopenAccountForm onClose={closeDialog} />
      </CDialog>
    </>
  );
};

export default ReopenAccount;
